import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class ModuleImage extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M3.9,7.7c1,0,1.8-0.8,1.8-1.8S4.9,4.1,3.9,4.1S2.1,4.9,2.1,5.9S2.9,7.7,3.9,7.7z M3.9,4.7c0.7,0,1.2,0.5,1.2,1.2
          S4.5,7.1,3.9,7.1S2.7,6.5,2.7,5.9S3.2,4.7,3.9,4.7z"
          />
          <path
            d="M15.4,2.3H0.6L0.3,2.6v10.9l0.3,0.3h14.9l0.3-0.3V2.6L15.4,2.3z M15.1,2.9v1.3L10,9.6L7.3,8.2L7,8.2l-6.1,3.9V2.9H15.1z
           M0.9,13.1v-0.3l6.3-4.1L9.5,10l-2,1.3l0.3,0.5l2.4-1.5l0.1,0L15.1,5v8.1H0.9z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/ModuleImage.js